var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#ffd54f",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 0c-6.627 0-12 5.373-12 12 0 6.627 5.373 12 12 12v-6-1.5z",
    fill: "#deb945"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 9,
    fill: "#6d4c41",
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.362 14.316c-.141-.198-.369-.316-.612-.316h-13.5c-.243 0-.471.118-.612.316-.141.199-.176.453-.096.682 1.107 3.16 4.104 5.282 7.458 5.282s6.351-2.123 7.458-5.282c.08-.229.044-.483-.096-.682z",
    fill: "#e53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 14h-6.75c-.243 0-.471.118-.612.316-.141.199-.176.453-.096.682 1.107 3.16 4.104 5.282 7.458 5.282z",
    fill: "#c7322e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17 7c-1.103 0-2 .897-2 2s.897 2 2 2z",
    fill: "#5f4239"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m17.23 1.19-16.9 13.62c-.13-.55-.23-1.12-.28-1.7l15.57-12.55c.56.17 1.09.38 1.61.63z",
    fill: "#455a64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12.25 6h-8.5c-.414 0-.75.336-.75.75 0 2.757 2.243 5 5 5s5-2.243 5-5c0-.414-.336-.75-.75-.75z",
    fill: "#455a64"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3c4e57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.085 9.857-4.035 3.253c.05.58.15 1.15.28 1.7l4.866-3.922c-.42-.286-.795-.634-1.111-1.031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 6h-4.25c-.414 0-.75.336-.75.75 0 1.173.406 2.253 1.085 3.107.316.397.691.745 1.111 1.031.801.544 1.766.862 2.804.862z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.cc59750b35835f71faaa105ee49c39a8.svg";
export { ForwardRef as ReactComponent };